import React from "react";

import {
    Dialog,
    DialogContent,
    DialogContentText,
    Box,
    Button,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { apiRequest } from "../../../api/ApiCall";
import { useUserContext } from "../../../user-provider";
import { useUtilityContext } from "../../../utility-provider";
import MessageDialog from "../../components/MessageDialog";
import { LOCAL_CONSTANT } from "../../Const";
import { upsertLocationAddSurveyFileParam } from "../../components/LocationAddSurveyFunc";
import { setAddSurveyObj } from "../../../features/locationAddSurveySlice";

export interface cancellationAddSurveyModalProps {
    props: {
        open: boolean;
        handleModal: any;
        planAreaId: string | null;
        branch: string | null;
        mode: string;
    };
}

const CancellationAddSurveyModal: React.FC<cancellationAddSurveyModalProps> = ({
    props,
}) => {
    const dispatch = useAppDispatch();
    const user = useUserContext();
    const utilityCtx = useUtilityContext();

    const [open, setOpen] = React.useState(false);

    //追加調査を取得
    const objLocationAddSurvey = useAppSelector(
        (state) => state.locationAddSurvey.obj
    );
    //ユーザIDを取得
    const [userId, setUserId] = React.useState<string>("");

    const [message, setMessage] = React.useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] =
        React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);
    const [countStart, setCountStart] = React.useState(false);
    const [countTimer, setCountTimer] = React.useState<number>(5);

    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            //ユーザーIDを取得
            setUserId(JSON.parse(user.userData || "null").staff_number);
        }
    }, [user]);

    React.useEffect(() => {
        setOpen(props.open);
        if (props.open) {
            setCountStart(true);
        }
    }, [props.open]);

    const handleClose = () => {
        setCountTimer(5);
        setCountStart(false);
        props.handleModal(false);
    };

    const closeMessageDialog = () => {
        handleClose();
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    const onRegist = () => {
        (async () => {
            try {
                if (utilityCtx.showSpinner) {
                    utilityCtx.showSpinner();
                }
                let column = "";
                let message = "";
                if (props.mode === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
                    column = "cover_reference";
                    message = "承認済み参考値";
                } else if (
                    props.mode === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED
                ) {
                    column = "cover_confirmed";
                    message = "承認済み確定値";
                }
                setOpen(false);
                // メッセージモーダル表示
                setHasButton(false);
                setMessage(`${message}を修正中です`);
                setMessageDialogOpen(true);

                const params = upsertLocationAddSurveyFileParam({
                    objLocationAddSurvey: objLocationAddSurvey,
                    plan_area_id: props.planAreaId,
                    branch: props.branch,
                    uploadFile: "",
                    pdfFileName: "",
                    column: column,
                    user_id: userId,
                    fileName: "表紙",
                    status: props.mode,
                });
                await apiRequest(params);
                dispatch(
                    setAddSurveyObj({
                        ...objLocationAddSurvey,
                        approval_mgr_flag: params.query.approval_mgr_flag,
                        approval_mgr_user: params.query.approval_mgr_user,
                        approval_mgr_department:
                            params.query.approval_mgr_department,
                        approval_mgr_date: params.query.approval_mgr_date,
                        approval_mgr_stamp: params.query.approval_mgr_stamp,
                        approval_gm_flag: params.query.approval_gm_flag,
                        approval_gm_user: params.query.approval_gm_user,
                        approval_gm_department:
                            params.query.approval_gm_department,
                        approval_gm_date: params.query.approval_gm_date,
                        approval_gm_stamp: params.query.approval_gm_stamp,
                        approval_research_mgr_flag:
                            params.query.approval_research_mgr_flag,
                        approval_research_mgr_user:
                            params.query.approval_research_mgr_user,
                        approval_research_mgr_department:
                            params.query.approval_research_mgr_department,
                        approval_research_mgr_date:
                            params.query.approval_research_mgr_date,
                        approval_research_mgr_stamp:
                            params.query.approval_research_mgr_stamp,
                        approval_research_gm_flag:
                            params.query.approval_research_gm_flag,
                        approval_research_gm_user:
                            params.query.approval_research_gm_user,
                        approval_research_gm_department:
                            params.query.approval_research_gm_department,
                        approval_research_gm_date:
                            params.query.approval_research_gm_date,
                        approval_research_gm_stamp:
                            params.query.approval_research_gm_stamp,
                        cover_confirm_excel_path:
                            params.query.cover_confirm_excel_path,
                        cover_confirm_excel_user:
                            params.query.cover_confirm_excel_user,
                        cover_confirm_pdf_path:
                            params.query.cover_confirm_pdf_path,
                        cover_confirm_pdf_user:
                            params.query.cover_confirm_pdf_user,
                        approval_reference_staff_flag:
                            params.query.approval_reference_staff_flag,
                        approval_reference_staff_user:
                            params.query.approval_reference_staff_user,
                        approval_reference_staff_department:
                            params.query.approval_reference_staff_department,
                        approval_reference_staff_date:
                            params.query.approval_reference_staff_date,
                        approval_reference_staff_stamp:
                            params.query.approval_reference_staff_stamp,
                        approval_reference_research_mgr_flag:
                            params.query.approval_reference_research_mgr_flag,
                        approval_reference_research_mgr_user:
                            params.query.approval_reference_research_mgr_user,
                        approval_reference_research_mgr_department:
                            params.query
                                .approval_reference_research_mgr_department,
                        approval_reference_research_mgr_date:
                            params.query.approval_reference_research_mgr_date,
                        approval_reference_research_mgr_stamp:
                            params.query.approval_reference_research_mgr_stamp,
                        approval_reference_research_gm_flag:
                            params.query.approval_reference_research_gm_flag,
                        approval_reference_research_gm_user:
                            params.query.approval_reference_research_gm_user,
                        approval_reference_research_gm_department:
                            params.query
                                .approval_reference_research_gm_department,
                        approval_reference_research_gm_date:
                            params.query.approval_reference_research_gm_date,
                        approval_reference_research_gm_stamp:
                            params.query.approval_reference_research_gm_stamp,
                        approval_reference_rm_flag:
                            params.query.approval_reference_rm_flag,
                        approval_reference_rm_user:
                            params.query.approval_reference_rm_user,
                        approval_reference_rm_department:
                            params.query.approval_reference_rm_department,
                        approval_reference_rm_date:
                            params.query.approval_reference_rm_date,
                        approval_reference_rm_stamp:
                            params.query.approval_reference_rm_stamp,
                    })
                );
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                setHasButton(true);
                setMessage(`${message}を修正しました`);
            } catch (e) {
                console.log(e);
                setHasButton(true);
                setMessage(`${message}を修正に失敗しました`);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    // 計測カウントダウン
    React.useEffect(() => {
        const countDownInterval = setInterval(() => {
            if (countStart) {
                if (countTimer === 1) {
                    clearInterval(countDownInterval);
                    setCountStart(false);
                } else if (countTimer && countTimer > 1) {
                    setCountTimer(countTimer - 1);
                }
            } else {
                clearInterval(countDownInterval);
            }
        }, 1000);
        return () => {
            clearInterval(countDownInterval);
        };
    }, [countTimer, countStart]);

    const selectWord = (target: string) => {
        let word = "";
        if (props.mode === LOCAL_CONSTANT.LABEL.COVER_REFERENCE) {
            if (target === "1") {
                word = "承認済み参考値を修正しますか";
            } else if (target === "2") {
                word = "※参考値用の表紙を修正した場合";
            } else if (target === "3") {
                word = "再度参考値依頼が必要になります";
            }
        } else if (props.mode === LOCAL_CONSTANT.LABEL.COVER_CONFIRMED) {
            if (target === "1") {
                word = "承認済み確定値を修正しますか";
            } else if (target === "2") {
                word = "※確定値用の表紙を修正した場合";
            } else if (target === "3") {
                word = "再度確定値依頼が必要になります";
            }
        }

        return word;
    };

    return (
        <div>
            <Dialog
                open={open}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText>{selectWord("1")}</DialogContentText>
                    <DialogContentText sx={{ color: "red" }}>
                        {selectWord("2")}
                    </DialogContentText>
                    <DialogContentText sx={{ color: "red" }}>
                        {selectWord("3")}
                    </DialogContentText>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-around",
                            margin: "10px 0",
                        }}
                    >
                        <Box>
                            <Button
                                variant="outlined"
                                color="success"
                                size="medium"
                                onClick={handleClose}
                            >
                                キャンセル
                            </Button>
                        </Box>
                        {countStart && (
                            <Box>
                                <Button
                                    variant="contained"
                                    color="error"
                                    size="medium"
                                >
                                    {countTimer}
                                </Button>
                            </Box>
                        )}
                        {!countStart && (
                            <Box>
                                <Button
                                    variant="contained"
                                    color="error"
                                    size="medium"
                                    onClick={onRegist}
                                >
                                    修正する
                                </Button>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
            <MessageDialog
                props={{
                    open: messageDialogOpen,
                    handleModal: closeMessageDialog,
                    body: message,
                    hasButton: hasButton,
                    buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
                }}
            />
        </div>
    );
};

export default CancellationAddSurveyModal;
